import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import styled from 'styled-components';
import { Text, Icon, Tooltip } from '../../../../../components';
import { useDetectScrolledToBottom } from '../../../../../hooks/useDetectScrolledToBottom';

const VersionHistoryContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 250px;
  flex-shrink: 0;
  border-right: 1px solid var(--border-muted);
  flex-grow: 1;
  box-sizing: border-box;
`;

const VersionHistoryContent = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 2px;
`;

const VersionHistoryLabel = styled(Text)`
  margin-bottom: 12px;
  padding: 0px 12px;
  vertical-align: middle;
`;

const VersionHistoryItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12px 16px;
  border-radius: 6px;
  cursor: pointer;
  overflow: hidden;
  box-sizing: border-box;
  background-color: ${(props) => (props.$selected ? 'var(--wash-gray-pressed)' : 'transparent')};

  &:hover {
    background-color: var(--wash-gray-hover);
  }
`;

const VersionsHistory = ({
  versions,
  selectedVersion,
  setSelectedVersion,
  fetchNextPage,
  hasNextPage
}) => {
  const containerRef = useRef(null);

  useDetectScrolledToBottom(containerRef, () => {
    if (hasNextPage && fetchNextPage) {
      fetchNextPage();
    }
  });

  return (
    <VersionHistoryContainer ref={containerRef}>
      <VersionHistoryContent>
        <VersionHistoryLabel $small $bold $color='var(--content-subtitle)'>
          Version History
        </VersionHistoryLabel>
        {versions.map((version) => (
          <VersionHistoryItem
            key={version.id}
            onClick={() => setSelectedVersion(version)}
            $selected={version.createdAt === selectedVersion.createdAt}
          >
            <Text>{moment(version.createdAt).format('MMM D, YYYY [at] h:mm a')} </Text>
            {version.answer?.isCanned && (
              <Tooltip content='Failed attempt'>
                <Icon name='alert' displaySize={16} color='var(--content-body)' />
              </Tooltip>
            )}
          </VersionHistoryItem>
        ))}
      </VersionHistoryContent>
    </VersionHistoryContainer>
  );
};

VersionsHistory.propTypes = {
  versions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      createdAt: PropTypes.string.isRequired
    })
  ).isRequired,
  selectedVersion: PropTypes.shape({
    id: PropTypes.string.isRequired,
    createdAt: PropTypes.string.isRequired
  }).isRequired,
  setSelectedVersion: PropTypes.func.isRequired,
  fetchNextPage: PropTypes.func,
  hasNextPage: PropTypes.bool
};

VersionsHistory.defaultProps = {
  fetchNextPage: null,
  hasNextPage: false
};

export { VersionsHistory };
